module.exports = __webpack_public_path__ + "static/ru-sm-3-6887884e4877625723df7e8a3acfbbf1.png";